<div class="layout">
  <app-header></app-header>
  <div class="layout__content">
    <app-sidebar (sidebarToggle)="onSidebarToggle($event)"></app-sidebar>
    <main class="layout__main" [class.layout__main--sidebar-collapsed]="!isSidebarOpen">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
